import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { WelcomePassAdmin } from "./WelcomePassAdmin";
import { SchoolEmailLists } from "./SchoolEmailLists";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en", { month: "short", day: "numeric" }) : "—");

export const ProspectNotifyPanel = () => {
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState("New Prospect in-house dates are open!");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/prospect/notify-list").then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);
  const send = async () => {
    if (!window.confirm(`Send this to ${rows.length} famil${rows.length === 1 ? "y" : "ies"}?`)) return;
    setBusy(true);
    try { const r = await api.post("/admin/prospect/notify-list/send", { title, body }); toast.success(`Sent to ${r.data.sent} (${r.data.emailed} emailed)`); load(); }
    catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-6 space-y-5" data-testid="prospect-notify-panel">
      <WelcomePassAdmin />
      <SchoolEmailLists />
      <div className="bg-white rounded-2xl border border-slate-200 p-4 space-y-3">
        <p className="font-display font-bold text-navy">Notify Prospect families ({rows.length} waiting)</p>
        <p className="text-xs text-slate-500">Families who asked to hear when post-November 13 dates & prices open. Sends an in-app message and an email.</p>
        <Input value={title} onChange={(e) => setTitle(e.target.value)} className="rounded-xl" data-testid="prospect-notify-title" />
        <Textarea value={body} onChange={(e) => setBody(e.target.value)} placeholder="New dates and prices…" className="rounded-xl" rows={4} data-testid="prospect-notify-body" />
        <Button onClick={send} disabled={busy || !rows.length || !title.trim() || !body.trim()} className="rounded-full bg-gold text-navy font-bold hover:bg-gold/90" data-testid="prospect-notify-send">Send to list</Button>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm" data-testid="prospect-notify-table">
          <thead className="bg-slate-50 text-xs text-slate-500 text-left"><tr><th className="p-3">Parent</th><th className="p-3">Email</th><th className="p-3">Explorers</th><th className="p-3">Joined</th><th className="p-3">Last notified</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`prospect-notify-row-${r.id}`}>
                <td className="p-3 font-semibold text-navy">{r.parent_name}</td><td className="p-3">{r.email}</td>
                <td className="p-3">{r.explorers.join(", ")}</td><td className="p-3">{fmt(r.joined_at)}</td><td className="p-3">{fmt(r.notified_at)}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={5} className="p-6 text-center text-slate-400">No families on the list yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
